<script lang="ts">
  // Global polite + assertive live regions. Screen-reader only. `live.announce()` /
  // `live.alert()` drive these from anywhere (copy actions, route changes, errors).
  import { live } from "../a11y/live.svelte";
</script>

<div class="sr-only" role="status" aria-live="polite" aria-atomic="true" data-focus-trap-exempt>{live.polite}</div>
<div class="sr-only" role="alert" aria-live="assertive" aria-atomic="true" data-focus-trap-exempt>{live.assertive}</div>
